import React from 'react';
import styles from './AvailabilitySelectionModule.module.css';
import BookingInfo from './components/BookingInfo.component';
import AvailabilitySelector from './components/AvailabilitySelector.component';
import AvailabilitySelectionSkeleton from './components/AvailabilitySelectionSkeleton.component';
import { MentorCheckoutInfo } from './AvailabilitySelectionModule.machine';
import { calculateSessionCost } from '@/utils/calculateSessionCost';

interface AvailabilitySelectioViewProps {
  mentor_info: MentorCheckoutInfo;
  duration: 30 | 60;
  pages: string[][];
  toggleDuration: () => void;
  state: 'paginating' | 'start' | 'last' | 'expanded';
  increment: () => void;
  decrement: () => void;
  expanded_index: number;
  toggleExpand: (index: number) => void;
  selectSlot: (datetime: string) => void;
  isLoading?: boolean;
}

const AvailabilitySelectionView = ({
  mentor_info,
  duration,
  toggleDuration,
  pages,
  state,
  increment,
  decrement,
  expanded_index,
  toggleExpand,
  selectSlot,
}: AvailabilitySelectioViewProps) => {
  const sessionCostResult = calculateSessionCost({
    duration,
    originalHourlyRate: mentor_info.original_hourly_rate,
    mentorSlug: mentor_info.slug,
    discountCode: mentor_info.discount_code,
  });

  return (
    <div className={styles.container}>
      <BookingInfo
        mentor_info={mentor_info}
        duration={duration}
        price={sessionCostResult.finalCost}
        toggleDuration={toggleDuration}
      />
      <AvailabilitySelector
        pages={pages}
        state={state}
        increment={increment}
        decrement={decrement}
        expanded_index={expanded_index}
        toggleExpand={toggleExpand}
        selectSlot={selectSlot}
      />
    </div>
  );
};

export default AvailabilitySelectionView;
